import React from "react";

import { Application } from "models/application/Application";

import Drawer from "components/common/drawer/Drawer";

import PreviewApplication from "./Preview.template";

export default function PreviewApplicationComponent({
  application,
  drawerProps
}: {
  application: Application;
  drawerProps?: any;
}) {
  return (
    <Drawer
      {...drawerProps}
      render={({ close }: { close: () => void }) => (
        <PreviewApplication application={application} close={close} />
      )}
    />
  );
}
